<template>
  <div class="case-detail-gene-acmg-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $t('DIALOG.caseDetailGeneACMG.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '5px' }"></div>
    <div v-if="acmg" class="data-container col-block">
      <div class="acmg-table-container col-block">
        <div class="acmg-table-block" v-for="(variant, vkey, vindex) in variants" :key="vindex">
          <div class="acmg-table">
            <!--  -->
            <div class="table-row row-block stretch">
              <div class="table-col col-block" :style="{ flex: 1 }">
                <div class="table-cell hgvsc col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div
                    class="table-content ellipsis"
                    :title="variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'"
                    v-html="variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'"
                  ></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="table-col tab col-block" :style="{ flex: 3 }">
                <div class="table-cell consequence col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="table-content" v-html="getACMGConsequence(gene, vkey)"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="tab-container row-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="tab-block row-block" :class="{ display: display[vkey] }" @click="e => display[vkey] = !display[vkey]">
                    <div :style="{ width: '16px' }"></div>
                    <div class="tab-title">{{ $t('DIALOG.caseDetailGeneACMG.___tabTitle') }}</div>
                    <div :style="{ width: '8px' }"></div>
                    <img :src="require('../../assets/images/new-tab-display-icon.svg')" alt="">
                    <div :style="{ width: '8px' }"></div>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="display[vkey]">
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell criteria col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">
                      <button class="reset-button gray-button circle-button" :disabled="!caseData.edit_permission" @click="e => resetACMG(gene, vkey)">
                        <span>{{ $t('COMMON.button.___reset') }}</span>
                      </button>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell benign col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___benignCriteria') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell pathogenic col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___pathogenicCriteria') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell strength-of-evidence col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___strengthofEvidence') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell benign-strong col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___strong') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell benign-supporting col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___supporting') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-supporting col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___supporting') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-moderate col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___moderate') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-strong col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___strong') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-very-strong col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___veryStrong') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___populationData') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BA1'"
                      :acmgType="'benign-strong'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BS1'"
                      :acmgType="'benign-strong'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BS2'"
                      :acmgType="'benign-strong'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PM2'"
                      :acmgType="'pathogenic-moderate'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PS4'"
                      :acmgType="'pathogenic-strong'"
                      :disabled="!caseData.edit_permission"
                      :borCorReverse="true"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content" v-html="$t('DIALOG.caseDetailGeneACMG.table.title.___allelicEvidenceCosegrgationData')">
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BS4'"
                      :acmgType="'benign-strong'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP2'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP5'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-sub-col-container col-block" :style="{ flex: 3 }">
                  <div class="table-sub-cell-container col-block">
                    <div class="table-sub-col-block low-row row-block">
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col col-block">
                          <acmgItem
                            :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                            :acmgKey="'PP1'"
                            :acmgType="'pathogenic-supporting'"
                            :disabled="!caseData.edit_permission"
                            @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                          ></acmgItem>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                    </div>
                    <div class="table-sub-col-block row-block">
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col col-block">
                          <!--  -->
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col col-block">
                          <acmgItem
                            :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                            :acmgKey="'PM3'"
                            :acmgType="'pathogenic-moderate'"
                            :disabled="!caseData.edit_permission"
                            @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                          ></acmgItem>
                          <acmgItem
                            :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                            :acmgKey="'PM6'"
                            :acmgType="'pathogenic-moderate'"
                            :disabled="!caseData.edit_permission"
                            @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                          ></acmgItem>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col col-block">
                          <acmgItem
                            :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                            :acmgKey="'PS2'"
                            :acmgType="'pathogenic-strong'"
                            :disabled="!caseData.edit_permission"
                            :borCorReverse="true"
                            @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                          ></acmgItem>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content" v-html="$t('DIALOG.caseDetailGeneACMG.table.title.___computationPredictiveData')">
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP1'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP3'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP4'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP7'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PP2'"
                      :acmgType="'pathogenic-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PP3'"
                      :acmgType="'pathogenic-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PM1'"
                      :acmgType="'pathogenic-moderate'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PM4'"
                      :acmgType="'pathogenic-moderate'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PM5'"
                      :acmgType="'pathogenic-moderate'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PS1'"
                      :acmgType="'pathogenic-strong'"
                      :disabled="!caseData.edit_permission"
                      :borCorReverse="true"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PVS1'"
                      :acmgType="'pathogenic-very-strong'"
                      :disabled="!caseData.edit_permission"
                      :borCorReverse="true"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row low-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___functionalData') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BS3'"
                      :acmgType="'benign-strong'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PS3'"
                      :acmgType="'pathogenic-strong'"
                      :disabled="!caseData.edit_permission"
                      :borCorReverse="true"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___other') }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'BP6'"
                      :acmgType="'benign-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PP4'"
                      :acmgType="'pathogenic-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <acmgItem
                      :acmgData="acmg[(gene.SYMBOL || '')][vkey]"
                      :acmgKey="'PP5'"
                      :acmgType="'pathogenic-supporting'"
                      :disabled="!caseData.edit_permission"
                      @setValue="(tag, newTag) => setACMG(gene, vkey, tag, newTag)"
                    ></acmgItem>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <!--  -->
            </template>
            <div class="table-row row-block stretch">
              <div class="table-col col-block" :style="{ flex: 1 }">
                <div class="table-cell automated-criteria col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___automatedCriteria') }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div v-if="display[vkey]" class="table-col col-block" :style="{ flex: 3 }">
                <div class="table-cell explanation col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="table-content">{{ $t('DIALOG.caseDetailGeneACMG.table.title.___explanation') }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
            <!--  -->
            <template v-if="acmgResults[vkey].length">
              <template v-if="display[vkey]">
                <div class="table-row wrap-row row-block flex-start stretch" v-for="(acmgResult, arindex) in acmgResults[vkey]" :key="arindex">
                  <div class="table-col col-block" :style="{ width: '25%', 'min-height': '50px' }">
                    <div class="table-cell selected-col-title row-block" :class="[acmgResult.class + '-title']">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content">{{ getACMGTag(vkey, acmgResult) + ': ' }}<span class="type">{{ acmgResult.type }}</span></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                  <div class="table-col col-block" :style="{ width: '75%', 'min-height': '50px' }">
                    <div class="table-cell selected-col col-block">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content" v-html="variant[acmgResult.title + '_explanation'] || '- -'"></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="table-row wrap-row row-block flex-start flex-wrap stretch" :class="['wrap-4']">
                  <div v-for="(acmgResult, arindex) in acmgResults[vkey]" class="table-col col-block" :style="{ width: '25%', height: '50px' }" :key="arindex">
                    <div class="table-cell selected-col-title row-block" :class="[acmgResult.class + '-title']">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content">{{ getACMGTag(vkey, acmgResult) + ': ' }}<span class="type">{{ acmgResult.type }}</span></div>
                      <div :style="{ width: '8px' }"></div>
                      <borCor
                        v-if="variant[acmgResult.title + '_explanation']"
                        :width="'400px'"
                        :reverse="arindex % 4 >= 2"
                        :background="'white'"
                        :border="'#707070'"
                        :radius="'0px'"
                        :blockStyle="{ padding: '6px 8px' }"
                      >
                        <div slot="trigger">
                          <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                        </div>
                        <div class="content col-block" slot="content">
                          <div class="text" v-html="variant[acmgResult.title + '_explanation']"></div>
                        </div>
                      </borCor>
                      <img v-else :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                  <div v-if="acmgResults[vkey].length % 4" class="table-col col-block empty" :style="{ flex: 1, height: '50px' }">
                    <div class="table-cell selected-col-title row-block">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content"></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import acmgItem from '../case/acmgItem.vue'
import borCor from '../tool/borCor'
import { acmgMap } from '../../constants/global/data'

export default {
  components: {
    acmgItem,
    borCor
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      acmg: null,
      display: {}
    }
  },
  computed: {
    acmgResults () {
      return Object.entries(this.acmg[(this.gene.SYMBOL || '')]).reduce((result, [vkey, acmg]) => {
        return {
          ...result,
          [vkey]: Object.entries(acmg).filter(([_, value]) => value).map(([key]) => this.acmgMap[key]).filter(x => x)
        }
      }, {})
    },
    // param
    caseData () {
      return this.param.caseData
    },
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    type () {
      return this.param.type
    },
    // global
    acmgMap () { return acmgMap }
  },
  created () {
    this.acmg = this.param.acmg
    this.display = {
      ...this.display,
      ...Object.keys(this.variants).reduce((s, vkey) => ({ ...s, [vkey]: false }), {})
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    getACMGTag (vkey, acmgResult) {
      let acmgTag = (this.acmg[(this.gene.SYMBOL || '')][vkey][acmgResult.title + '_tag'] || acmgResult.title)
      return acmgResult.title + (acmgResult.title !== acmgTag ? ('(' + acmgTag.match(/^([^\d]*)\d+/)[1] + ')') : '')
    },
    // parent
    getACMGConsequence (gene, vkey) {
      return this.param.functions['getACMGConsequence'](gene, vkey)
    },
    async setACMG (gene, vkey, tag, newTag) {
      this.setLoadingAction(true)
      let result = await this.param.functions['setACMG'](gene, vkey, tag, newTag)
      this.acmg[(gene.SYMBOL || '')][vkey] = {
        ...this.acmg[(gene.SYMBOL || '')][vkey],
        [tag]: result,
        [tag + '_tag']: newTag || this.acmg[(gene.SYMBOL || '')][vkey][tag + '_tag']
      }
      this.setLoadingAction(false)
    },
    async resetACMG (gene, vkey) {
      this.setLoadingAction(true)
      await this.param.functions['resetACMG'](gene, vkey)
      let variant = gene.variants[vkey]
      let defaultACMG = Object.keys(this.acmgMap).concat(['ACMG_Classification']).reduce((s, key) => ({ ...s, [key]: variant[key] }), {})
      this.acmg[(gene.SYMBOL || '')][vkey] = defaultACMG
      this.setLoadingAction(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneACMG.vue